module.exports = __webpack_public_path__ + "img/google_create.d2e490d1.jpg";